import $ from 'jquery';
import '../vendor/slick';
import {register} from '@shopify/theme-sections';

register('blog-carousel', {
  onLoad() {
    this.$container = $(this.container);
    this.namespace = `.${this.id}`;
    this.$slideshow = $('[data-blog-carousel]', this.$container);

    this.$slideshow.slick({
      arrows: true,
      autoplay: false,
      centerMode: true,
      centerPadding: '25%',
      cssEase: 'ease-in-out',
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            centerPadding: '0'
          }
        }
      ]
    });
  },

  onBlockSelect(event) {
    const $target = $(event.target);
    const $slide = $target.closest('[data-slick-index]');
    const index = $slide.attr('data-slick-index');

    this.$slideshow.slick('slickPause');
    this.$slideshow.slick('slickGoTo', index);
  },

  onDeselect() {
    this.$slideshow.slick('slickPlay');
  },

  onUnload() {
    this.$container.off(this.namespace);
    this.$slideshow.slick('unslick');
  },
});
